// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__OI1RX","LogoIcon":"Footer_LogoIcon__dEwJw","Icon":"Footer_Icon__qP7sj"};